import {Config} from "angular-ecmascript/module-helpers";
import {LoginView} from "./views/login/login";
import {BranchSelectionView} from "./views/branch-selection/branch-selection";
import {DashboardView} from "./views/dashboard/dashboard";
import {BookingsView} from "./views/bookings/bookings";
import {BookingDetailsView} from "./views/booking-details/booking-details";
import {ScanTagView} from "./views/scantag/scantag";
import {VehicleDetailsView} from "./views/vehicle-details/vehicle-details";
import {NewBookingServiceView} from "./views/new-booking-service/new-booking-service";
import {NewBookingDurationView} from "./views/new-booking-duration/new-booking-duration";
import {NewBookingResourceView} from "./views/new-booking-resource/new-booking-resource";
import {NewBookingDateView} from "./views/new-booking-date/new-booking-date";
import {NewBookingTimeView} from "./views/new-booking-time/new-booking-time";
import {NewBookingOptionsView} from "./views/new-booking-options/new-booking-options";
import {SearchView} from "./views/search/search";
import {SettingsView} from "./views/settings/settings";
import Settings from "./model/settings.model";

export default class RoutesConfig extends Config {
    static $inject = ['$stateProvider', '$urlRouterProvider'];

    configure() {
        this.$stateProvider
            .state('login', Object.assign({
                url: '/login'
            }, LoginView))

            .state('branch-selection', Object.assign({
                url: '/branch-selection'
            }, BranchSelectionView))

            .state('tab', {
                url: '/tab',
                abstract: true,
                templateUrl: 'templates/tabs.html'
            })

            .state('tab.dashboard', {
                url: '/dashboard',
                views: {
                    'tab-dashboard': DashboardView
                }
            })

            .state('tab.bookings', {
                url: '/bookings',
                views: {
                    'tab-bookings': BookingsView
                }
            })

            .state('tab.booking-details', {
                url: '/booking-details/:bookingId',
                views: {
                    'tab-bookings': BookingDetailsView
                }
            })

            .state('tab.booking-search', {
                url: '/booking/search',
                views: {
                    'tab-bookings': SearchView
                }
            })

            .state('tab.new-booking-service', {
                url: '/new-booking/service',
                views: {
                    'tab-bookings': NewBookingServiceView
                }
            })

            .state('tab.new-booking-duration', {
                url: '/new-booking/duration',
                views: {
                    'tab-bookings': NewBookingDurationView
                }
            })

            .state('tab.new-booking-resource', {
                url: '/new-booking/resource',
                views: {
                    'tab-bookings': NewBookingResourceView
                }
            })

            .state('tab.new-booking-date', {
                url: '/new-booking/date',
                views: {
                    'tab-bookings': NewBookingDateView
                }
            })

            .state('tab.new-booking-time', {
                url: '/new-booking/time',
                views: {
                    'tab-bookings': NewBookingTimeView
                }
            })

            .state('tab.new-booking-options', {
                url: '/new-booking/options',
                views: {
                    'tab-bookings': NewBookingOptionsView
                }
            })

            .state('tab.scantag', {
                url: '/scantag',
                views: {
                    'tab-vehicle': ScanTagView
                }
            })

            .state('tab.vehicle-details', {
                url: '/vehicle-details/:vehicleId?tagNumber',
                views: {
                    'tab-vehicle': VehicleDetailsView
                }
            })

            .state('tab.vehicle-booking-details', {
                url: '/vehicle-booking-details/:bookingId?showCustomer&showVehicle',
                views: {
                    'tab-vehicle': BookingDetailsView
                }
            })

            .state('tab.settings', {
                url: '/settings',
                views: {
                    'tab-settings': SettingsView
                }
            });

        let settings = Settings.load();
        let defaultPage = 'tab/dashboard';
        if (!settings || !settings.user || !settings.user.token) {
            defaultPage = '/login';
        }

        this.$urlRouterProvider.otherwise(defaultPage);
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/routes.config.js